import React, { useState } from 'react';

import ProfileTab from './components/ProfileTab';
import PasswordTab from './components/PasswordTab';
import SubscriptionTab from './components/SubscriptionTab';
import Modal from './components/Modal';
import DeleteTab from './components/DeleteTab';

const Edit = ({ interest_areas, backup_profile_images }) => {
	const [modalState, setModalState] = useState(false);

	const toggleModal = () => {
		setModalState(!modalState);
	};

	const turnOffModal = () => {
		setModalState(false);
	};

	return (
		<div className="small-10 small-offset-1" id="edit-user">
			<h1>My Account settings</h1>

			<ProfileTab
				interest_areas={interest_areas}
				backup_profile_images={backup_profile_images}
				imageSize={100}
			/>
			<PasswordTab />
			<SubscriptionTab toggleModal={toggleModal} subscribed={false} />
			<Modal
				modalState={modalState}
				turnOffModal={turnOffModal}
				subscribed={false}
			/>
			<DeleteTab />
		</div>
	);
};

export default Edit;
